import { ChangeDetectionStrategy, Component, booleanAttribute, input } from '@angular/core';

/**
 * The one field label in this UI. Says what the form will not submit without — an asterisk while
 * the question stands, and the label itself in the refusal colour once that field is the thing
 * still owed — so a greyed-out submit button is never the only account of why nothing happens.
 *
 * An attribute on the label already there rather than a wrapper around it, so a `<label>`'s span
 * and a `<fieldset>`'s legend read at the same weight without either being re-nested.
 */
@Component({
  selector: 'span[guaranteesLabel], legend[guaranteesLabel]',
  standalone: true,
  host: {
    class: 'text-sm font-semibold',
    '[class.text-neutral-700]': '!missing()',
    '[class.text-error-600]': 'missing()',
  },
  template: `<ng-content />
    @if (required()) {
      <span class="ml-0.5 text-error-600" aria-hidden="true">*</span>
    }`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldLabelComponent {
  /** The form refuses to submit without this field, whether or not it is answered right now. */
  required = input(false, { transform: booleanAttribute });
  /** Required and still unanswered — this field is one of the things holding the submit back. */
  missing = input(false, { transform: booleanAttribute });
}
